<template>
  <div class="update-password-comp">
    <div class="personal-center-title">
      <h3>Update Password</h3>
    </div>
    <el-form :model="operateForm" label-width="182px" :rules="operateRules" ref="passwordForm" class="update-pass-form" >
      <el-form-item label="Username">
        <el-input disabled v-model="userInfo.email"/>
      </el-form-item>
      <el-form-item prop="currentPasssword"  label="Current password" required>
        <el-input type="password" v-model.trim="operateForm.currentPasssword" placeholder="Please input current password" :minlength="6" :maxlength="20"/>
      </el-form-item>
      <el-form-item prop="newPasssword"  label="New password" required>
        <el-input type="password" v-model.trim="operateForm.newPasssword" placeholder="Please input new password(length:6~20) characters" :minlength="6" :maxlength="20"/>
      </el-form-item>
      <el-form-item prop="confirmPasssword"  label="Confirm new password" required>
        <el-input type="password" v-model.trim="operateForm.confirmPasssword" placeholder="Please input the new password again(length:6~20) characters" :minlength="6" :maxlength="20"/>
      </el-form-item>
      <el-form-item class="submit-wraper">
        <el-button type="primary" @click="submitPassword('passwordForm')">Submit</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: "updatePassword",
    data () {
      let validatePass = (rule, value, callback) => {
        if (!value) {
          console.log(1);
          callback(new Error('Please enter Password'));
        } else if (value.length < 6 || value.length > 20) {
          console.log(2);
          callback(new Error('Length of the password should be within 6-20 characters'));
        } else {
          callback();
        }
      };
      let validatePass1 = (rule, value, callback) => {
        if (!value) {
          callback(new Error('Please enter new password'));
        }  else if (value.length < 6 || value.length > 20) {
          callback(new Error('Length of the password should be within 6-20 characters'));
        } else {
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (!value) {
          callback(new Error('Please enter password again'));
        } else if (value !== this.operateForm.newPasssword) {
          callback(new Error('New password and confirmation of password do not match.!'));
        } else {
          callback();
        }
      };
      return {
        userInfo: '',
        operateForm:{
          currentPasssword:'',
          newPasssword:'',
          confirmPasssword:''
        },
        operateRules:{
          currentPasssword: [
            { validator: validatePass, trigger: 'blur' }
          ],
          newPasssword: [
            { validator: validatePass1, trigger: 'blur' }
          ],
          confirmPasssword: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
      }
    },
    computed: mapState([
      'KP'
    ]),
    created () {
      if(this.getToken('isLogin') == 100){
        let userInfo = this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv) || {}
        this.userInfo = JSON.parse(userInfo)
      }
    },
    methods: {
      // 修改密码
      submitPassword (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/onelink.mdata.main.api/user/changePassword', {
                userId:this.userInfo.id,
                oldPassword:this.operateForm.currentPasssword,
                newPassword:this.operateForm.newPasssword
              }).then((res) => {
              this.data = res.data;
              let changeFlag = this.data.data;
              if(changeFlag){
                this.$message.success('Your password has been successfully reset');
                setTimeout(() => {
                  this.$router.push({path:'/loginEn', query: {isReset: 1}})
                }, 300)
              }else{
                this.$message.error("Your password is incorrect, please re-enter")
              }
            }).catch((err) => {
              console.log(err)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .update-pass-form{
    margin-top: 48px;
    margin-left: 100px;
    overflow: hidden;
    .el-input{
      width: 320px
    }
    /deep/ .el-form-item__label{
      font-size: 14px;
      color: #606266;
      font-weight: 400;
    }
    .submit-wraper{
      .el-button{
        width: 320px;
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/personalCenterEn/updatePassword.vue